import React, { FC, useEffect, useState } from "react";
import { CartItem as TCartItem } from "../@types";
import { Minus, Plus, Spinner, Trash } from "@phosphor-icons/react";
import { formatAsMoney } from "../helpers/numbers";
import { useUpdateCartItem } from "../hooks/useUpdateCartItem";
import { useDebouncedValue } from "../hooks/useDebouncedValue";
import { useRemoveFromCart } from "../hooks/useRemoveFromCart";
import { Link } from "react-router-dom";

const CartItem: FC<{ item: TCartItem }> = ({ item }) => {
  const [quantity, setQuantity] = useState(item.quantity);
  const debouncedQuantity = useDebouncedValue(quantity, 500);

  const { updateCartItem } = useUpdateCartItem();

  useEffect(() => {
    if (debouncedQuantity !== item.quantity) {
      updateCartItem({
        cartItemId: item.id,
        quantity: debouncedQuantity,
      });
    }
  }, [debouncedQuantity, item.id, item, updateCartItem]);

  const { removeFromCart, removingFromCart } = useRemoveFromCart();

  return (
    <div className="flex gap-3 w-full">
      <Link to={`/marketplace/products/${item.product.id}`}>
        <img
          src={item.product.images[0].path}
          alt=""
          className="w-20 aspect-square rounded-md border"
        />
      </Link>
      <div className="flex flex-col flex-1 justify-between">
        <Link
          to={`/marketplace/products/${item.product.id}`}
          className="font-medium line-clamp-1 "
        >
          {item.product.name}
        </Link>
        <div className="font-medium">
          ₦{formatAsMoney(item.product.price || 0)}
        </div>
        <div className="flex-1" />
        <div className="flex items-center gap-2 text-sm">
          <button
            type="button"
            onClick={() => setQuantity((prev) => Math.max(prev - 1, 1))}
            className="p-1 rounded-full border border-gray-300 hover:bg-gray-200 text-visaro-orange"
          >
            <Minus size={14} />
          </button>
          <span>{quantity}</span>
          <button
            disabled={
              item?.product?.quantity - item?.product?.sales_count === quantity
            }
            type="button"
            onClick={() => setQuantity((prev) => prev + 1)}
            className="p-1 rounded-full border border-gray-300 hover:bg-gray-200 text-visaro-orange"
          >
            <Plus size={14} />
          </button>
        </div>
      </div>
      <button
        onClick={() => {
          removeFromCart(item.id);
        }}
        type="button"
        className="p-1 rounded-full border border-gray-300 hover:bg-gray-200 text-red-500 self-start"
      >
        {removingFromCart ? (
          <Spinner size={14} className="animate-spin" />
        ) : (
          <Trash size={14} />
        )}
      </button>
    </div>
  );
};

export default CartItem;
